import { render, staticRenderFns } from "./Ordering.vue?vue&type=template&id=0e2750a8&scoped=true"
import script from "./Ordering.vue?vue&type=script&lang=js"
export * from "./Ordering.vue?vue&type=script&lang=js"
import style0 from "./Ordering.vue?vue&type=style&index=0&id=0e2750a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2750a8",
  null
  
)

export default component.exports